import { Injectable } from '@angular/core';
import { BookWidgetAem } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { Store } from '@ngrx/store';
import * as fromAemActions from '../+state/actions/aem.actions';
import * as fromAemSelectors from '../+state/selectors/aem.selectors';

@Injectable({ providedIn: 'root' })
export class AemFacade {
  bookWidgetAem$ = this.store.select(fromAemSelectors.getBookWidgetAem);

  constructor(private store: Store) {}

  loadBookWidgetAem() {
    this.store.dispatch(fromAemActions.LoadBookWidgetAem());
  }

  storeBookWidgetAem(bookWidgetAem: BookWidgetAem) {
    this.store.dispatch(
      fromAemActions.LoadBookWidgetAemSuccess({ bookWidgetAem })
    );
  }
}
